import { useContext } from '@builder.io/qwik';
import { AppDataContext } from '~/contexts/AppDataContext';

export const useIsOdesaTemplate = () => {
  const appData = useContext(AppDataContext);
  if (!appData?.payloadToSSR?.template) {
    return false;
  }
  return appData.payloadToSSR.template === 'PostPageOdesa';
};
